import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { Provider } from 'react-redux';
import store from './store/index.js';
import 'react-toastify/dist/ReactToastify.css';
import NftServices from './services/nft.service.js';
import { configureNftServices } from '@cai/shared/chains/evm/normalize';
import { configureNftUriCreator } from '@cai/shared/chains/svm/api';

configureNftServices(NftServices);
configureNftUriCreator((nfts) => NftServices.createUris(nfts, 'Solana'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>,
  // </React.StrictMode>
);
